import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import { pricingPlanClasses } from './pricingPlanClasses';

const recommendedTextHeight = 32;

export const CardRoot = styled(Card, {
  name: 'AFPricingPlan'
})(({ theme }) => ({
  position: 'relative',
  width: 301,
  borderRadius: 4,
  border: 'none',
  boxShadow: theme.shadows[1],
  background: theme.palette.background.paper,
  padding: 0,
  [`& .${pricingPlanClasses.content}`]: {
    padding: theme.spacing(7.5, 3, 4, 3)
  },
  [`& .${pricingPlanClasses.mostPopular}`]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: recommendedTextHeight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.background.paper,
    background: theme.palette.violet[700]
  },
  [`& .${pricingPlanClasses.title}`]: {
    color: theme.palette.violet[800],
    marginBottom: theme.spacing(1)
  },
  [`& .${pricingPlanClasses.pricingContainer}`]: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: theme.spacing(1.5)
  },
  [`& .${pricingPlanClasses.total}`]: {
    display: 'flex',
    marginBottom: theme.spacing(3)
  },
  [`& .${pricingPlanClasses.description}`]: {
    marginBottom: theme.spacing(4.5)
  },
  [`& .${pricingPlanClasses.planContent}`]: {
    paddingTop: theme.spacing(4.5),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  [`& .${pricingPlanClasses.action}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3.5)
  }
}));
